import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import _ from 'lodash';
import useMobile from '../hooks/use-mobile';
const SIZES = {
  d96: [96, 80],
  d80: [80, 64],
  d64: [64, 56],
  d56: [56, 48],
  d48: [48, 40],
  d40: [40, 32],
  d32: [32, 24],
  d24: [24, 20],
  d16: [16, 12],
  f24: [24],
  f20: [20],
  f16: [16],
  f12: [12],
  f8: [8],
  f6: [6],
  f4: [4],
  f2: [2]
};
const StyledSpacer = styled.View`
  height: ${_ref => {
  let {
    height
  } = _ref;
  return height;
}}px;
  width: ${_ref2 => {
  let {
    width
  } = _ref2;
  return width;
}}px;
`;
export default function Spacer(props) {
  const mobile = useMobile();
  const method = mobile ? 'last' : 'head';

  const size = _[method](SIZES[props.size] || SIZES.f2);

  const height = props.height ? size : 0;
  const width = props.width ? size : 0;
  return /*#__PURE__*/React.createElement(StyledSpacer, {
    height: height,
    width: width
  });
}
Spacer.defaultProps = {
  size: 'f2',
  height: false,
  width: false
};
Spacer.propTypes = {
  size: PropTypes.oneOf(Object.keys(SIZES)),
  height: PropTypes.bool,
  width: PropTypes.bool
};
//# sourceMappingURL=index.js.map